import { render } from "./plain-text-primary-motion-text-display.vue?vue&type=template&id=1b85f15a"
import script from "./plain-text-primary-motion-text-display.vue?vue&type=script&lang=js"
export * from "./plain-text-primary-motion-text-display.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__